import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
declare let ga: Function;

@Injectable()
export class GoogleAnalyticsService {
  public RECENT: string;
  public REPORTS: string;
  public SUPPLY: string;
  public DEMAND: string;
  public MY_REPORTS: string;
  public MENU: string;

  constructor(public sharedService: SharedService) {
    this.RECENT = 'Recent';
    this.REPORTS = 'Reports';
    this.SUPPLY = 'Supply';
    this.DEMAND = 'Demand';
    this.MY_REPORTS = 'My Reports';
    this.MENU = 'Menu';
  }

  public setPageView(page: string) {
    ga('set', 'page', page);
    ga('send', 'pageview');
  }

  public sendEvent(eventCategory: string, eventAction: string, eventLabel: string = null, eventValue: number = null) {
    const event: any = {
      eventCategory: eventCategory,
      eventLabel: eventLabel,
      eventAction: eventAction,
      eventValue: eventValue,
    };
    ga('send', 'event', event);
    this.sharedService.sendMessage('GOOGLE_ANALYTICS_EVENT', event);
  }
}
